import { AccordionMarks, getMarks, typeMarks } from '@app/entities/Auto';
import { useAppSelector } from '@app/redux/hooks';
import { Button, ButtonSize, ButtonThemes } from '@app/shared';
import { MySelect } from '@app/shared/ui/ui-kit/FormField';
import { ElementIdTab, getProductType, Part } from '@entities/Product';
import { ChangeEvent, useState } from 'react';
import { IconChevronDown } from '@koleso-icons';
import { TitleBlock } from '../TitleBlock';
import classNames from 'classnames';

import styles from './FitsTheCar.module.scss';

export function FitsTheCar({ showBlock = true }: { showBlock?: boolean }) {
  const dataForCar = useAppSelector(getMarks);
  const part = useAppSelector(getProductType);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [fullShowAccordion, setFullShowAccordion] = useState<boolean>(false);

  const handlerSetActiveMark = (event: ChangeEvent<HTMLSelectElement>) => {
    setFullShowAccordion(true);
    if (event.target.value && event.target.value !== '-') {
      setActiveAccordion(event.target.value);
    }
    event.target.blur();
  };

  return (
    <div id={ElementIdTab.TabFitsTheCar} className={classNames(styles.Wrapper, { [styles.Show]: showBlock })}>
      <TitleBlock>Подходит к автомобилю</TitleBlock>
      <div className={styles.Header}>
        <div className={styles.Title}>Выберите подходящую марку автомобиля</div>
        <MySelect classNameSelect={styles.Select} onChange={handlerSetActiveMark}>
          <option value={'—'}>—</option>
          {Object.keys(dataForCar).map(mark => (
            <option className={styles.Mark} key={mark} value={mark}>
              {mark.toUpperCase()}
            </option>
          ))}
        </MySelect>
      </div>
      <div className={styles.List}>
        {Object.keys(dataForCar).map((mark, index) => (
          <AccordionMarks
            key={index}
            title={mark}
            models={dataForCar[mark]}
            active={activeAccordion === mark}
            type={Part.Tyres === part ? typeMarks.Tires : typeMarks.Disks}
            className={index > 7 && !fullShowAccordion && styles.hide}
          />
        ))}
      </div>

      {Object.keys(dataForCar).length > 7 && !fullShowAccordion && (
        <Button size={ButtonSize.S} themes={ButtonThemes.Black} className={styles.ButtonShow} onClick={() => setFullShowAccordion(true)}>
          Показать ещё авто
          <IconChevronDown width={16} height={16} />
        </Button>
      )}
    </div>
  );
}
